// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__bavLw","notes":"Notes_notes__2gZKK","note":"Notes_note__3Cc4X","markdown":"Notes_markdown__3_HHH"};